import { motion } from "framer-motion";

const steps = [
  {
    number: "01",
    title: "Llamada de Demo (20 minutos)",
    description:
      "Es una llamada de venta, no te vamos a hacer el verso. Respondemos todas tus preguntas, te mostramos cualquier funcionalidad que te genere dudas y te mostramos cuentas en vivo de clientes y resultados.",
  },
  {
    number: "02",
    title: "Armamos tu sistema — 7 a 10 días",
    description:
      "Completás un formulario simple con los detalles de tu negocio. Con la información correcta de tu negocio nos ponemos a trabajar en construir tu nuevo sitio web y sistema de marketing.",
  },
  {
    number: "03",
    title: "Llamada de entrega — 25 minutos",
    description:
      'Te vamos a mostrar tu nuevo sitio y sistema de marketing, respondemos todas tus preguntas, y te mostramos cómo funciona "todo". Y por todo nos referimos a apretar dos botones.',
  },
];

export const HowWeWorkSection = () => {
  return (
    <section
      id="proceso"
      className="bg-[#08080A] py-24 lg:py-[160px] relative scroll-mt-16"
    >
      <div className="container mx-auto px-6 max-w-[1200px]">
        <div className="max-w-3xl mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-[#71717A] font-mono text-[13px] tracking-[0.08em] uppercase mb-6">
              ● CÓMO TRABAJAMOS
            </p>
            <h2 className="text-[32px] md:text-[44px] lg:text-[56px] font-medium text-[#FAFAFA] tracking-[-0.03em] leading-[1.05]">
              Cómo es trabajar con nosotros.
            </h2>
          </motion.div>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-[60px] left-[15%] right-[15%] h-[1px] border-t border-dashed border-[#7C3AED]/30 z-0" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8 mb-12">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.2,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="relative z-10 flex flex-col items-center text-center lg:items-start lg:text-left"
              >
                <div className="w-[120px] h-[120px] rounded-full bg-[#0F0F11] border border-white/5 flex items-center justify-center mb-8 shadow-xl">
                  <span className="text-[48px] font-mono font-medium text-transparent bg-clip-text bg-gradient-to-r from-[#7C3AED] to-[#FB7185]">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-[#FAFAFA] text-[20px] font-medium tracking-[-0.03em] mb-4">
                  {step.title}
                </h3>
                <p className="text-[#A1A1AA] text-[15px] leading-[1.6] max-w-sm">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center text-[#A1A1AA] text-[15px] leading-[1.6] max-w-2xl mx-auto"
        >
          Y de ahí en más: soporte por WhatsApp con gente real, no con un
          ticket. Y un reporte todos los lunes.
        </motion.p>
      </div>
    </section>
  );
};
